import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarComposeFormStore"*/ './lazyIndex')
);

// InitActions - async since they can be used in non-compose packages
export let lazyShowFullCompose = new LazyAction(lazyModule, m => m.showFullCompose);
export let lazyShowFullComposeWithAttendee = new LazyAction(
    lazyModule,
    m => m.showFullComposeWithAttendee
);
export let lazyShowFullComposeInPopOut = new LazyAction(lazyModule, m => m.showFullComposeInPopOut);
export let lazyShowFullComposeInEditMode = new LazyAction(
    lazyModule,
    m => m.showFullComposeInEditMode
);
export let lazyShowFullComposeFromDeeplink = new LazyAction(
    lazyModule,
    m => m.showFullComposeFromDeeplink
);

export let lazyDuplicateEvent = new LazyAction(lazyModule, m => m.duplicateEvent);

// Selectors
export let lazyIsQuickComposeOpen = new LazyImport(lazyModule, m => m.isQuickComposeOpen);
export let lazyIsFullComposeOpen = new LazyImport(lazyModule, m => m.isFullComposeOpen);

// NOTE: these non-lazy actions (closeQuickComposeForm, closeFullComposeForm and showQuickCompose) are for subscription purposes only; do not invoke
export { default as closeQuickComposeForm } from './quickCompose/actionsV2/closeQuickComposeForm';
export { default as closeFullComposeForm } from './quickCompose/actionsV2/closeFullComposeForm';
export { default as showQuickCompose } from './quickCompose/actionsV2/showQuickCompose';
export { default as setCalendarId } from './quickCompose/actionsV2/setCalendarId';
export { default as onShowFullCompose } from './actions/onShowFullCompose';
